export function TranscriptSkeleton() {
	return (
		<div className="space-y-3 p-4" aria-busy="true" aria-live="polite">
			<div className="h-4 w-full rounded bg-muted animate-pulse" />
			<div className="h-4 w-full rounded bg-muted animate-pulse" />
			<div className="h-4 w-4/5 rounded bg-muted animate-pulse" />
			<div className="h-4 w-full rounded bg-muted animate-pulse" />
			<div className="h-4 w-3/4 rounded bg-muted animate-pulse" />
			<div className="h-4 w-full rounded bg-muted animate-pulse" />
			<div className="h-4 w-5/6 rounded bg-muted animate-pulse" />
		</div>
	)
}
